import {
    Box,
    Button
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import RofBatchData from '../apps/rofburns/flame-cap-kiln/data-monitoring/production/RofBatchData';
import RofBatchMedia from '../apps/rofburns/flame-cap-kiln/data-monitoring/production/RofBatchMedia';

export default function ProjectQuickLink() {
    let { projectId } = useParams();
    const [searchParams] = useSearchParams();
    const projectIdentifier = searchParams.get("projectIdentifier")
    const navigate = useNavigate()

    const handleNavigate = () => {
        navigate('/programs', { replace: true, state: { projectId: projectIdentifier, projectKey: projectId } })
    }

    return (
        <>
            <Box sx={{ display: 'flex' }}>
                <Button sx={{ display: 'flex', cursor: 'pointer', mr: 3 }} variant={'outlined'} onClick={() => navigate('/home')}>
                    <ArrowBack /> Back to Home
                </Button>
                <Button variant={'contained'} onClick={handleNavigate}>
                    Go to Project {projectIdentifier}
                </Button>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', pt: 3, gap: 5 }}>
                <RofBatchData projectKey={projectId} />
                <RofBatchMedia projectKey={projectId} />
            </Box>
        </>
    )
}